import { useEffect, useState } from 'react'
import { AnimatePresence } from 'framer-motion'

import TopContactBar from './TopContactBar.jsx'
import SiteNavbar from './SiteNavbar.jsx'
import SiteFooter from './SiteFooter.jsx'
import WhatsAppFloatingButton from './WhatsAppFloatingButton.jsx'
import SiteLoader from './SiteLoader.jsx'

export default function PageLayout({ children }) {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 450)
    return () => clearTimeout(t)
  }, [])

  return (
    <div className="min-h-screen">
      <AnimatePresence>{loading ? <SiteLoader /> : null}</AnimatePresence>

      <TopContactBar />
      <SiteNavbar />
      <WhatsAppFloatingButton />

      <div className="anchor-offset">{children}</div>
      <SiteFooter />
    </div>
  )
}

